import React from 'react';
import { Box } from '@mui/material';

const TunnelBox = props => {
    const { children, sx, ...rest } = props;

    return (
        <Box
            padding="30px"
            borderRadius="6px"
            sx={theme => ({
                border: `1px solid ${theme.palette.grey['A700']}`,
                '&:not(:last-child)': {
                    marginBottom: '20px',
                },
                ...(typeof sx === 'function' ? sx(theme) : sx),
            })}
            {...rest}
        >
            {children}
        </Box>
    );
};

TunnelBox.propTypes = { ...Box.propTypes };

export default TunnelBox;
